import { createHeadlessEditor } from '@lexical/headless'
import { $generateHtmlFromNodes } from '@lexical/html'

import { themeConfig as ThemeConfig } from './Editor.theme'
import { editorNodes } from './util/editorNodes'

export function getRichTextHTMLGenerator(callBack: (args) => void, commentRichTextJSON?: string) {
  if (!commentRichTextJSON) return undefined
  try {
    const editor = createHeadlessEditor({
      // eslint-disable-next-line no-console
      onError: (error) => console.warn('[getRichTextHTMLGenerator] Lexical error:', error),
      namespace: 'html-generator-editor',
      nodes: editorNodes,
      theme: ThemeConfig,
    })
    editor.setEditorState(editor.parseEditorState(JSON.parse(commentRichTextJSON)))

    editor.getEditorState().read(() => {
      const htmlString = $generateHtmlFromNodes(editor, null)
      callBack(htmlString)
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[getRichTextHTMLGenerator] Failed to parse rich text, falling back to plain text:', error)
  }
}
